/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { IReferenceNode } from '../../core/models/IReferenceNode';
import { Node } from '../../core/models/Node';
import { IDefinition } from '../../core/models/common/IDefinition';
import { SecurityScheme } from '../../core/models/common/SecurityScheme';
import { AaiOAuthFlows } from './AaiOAuthFlows';
import { Document } from '../../core/models/Document';

/**
 * @author Jakub Senko <jsenko@redhat.com>
 * @param {Node} parent
 * @param {string} name
 * @class
 * @extends SecurityScheme
 */
export abstract class AaiSecurityScheme extends SecurityScheme implements IReferenceNode, IDefinition {
    public $ref : string;

    public scheme : string;

    public flows : AaiOAuthFlows;

    public openIdConnectUrl : string;

    public bearerFormat : string;

    public constructor(parent? : any, name? : any) {
        if(((parent != null && parent instanceof <any>Node) || parent === null) && ((typeof name === 'string') || name === null)) {
            let __args = arguments;
            super(name);
            if(this.$ref===undefined) this.$ref = null;
            if(this.scheme===undefined) this.scheme = null;
            if(this.flows===undefined) this.flows = null;
            if(this.openIdConnectUrl===undefined) this.openIdConnectUrl = null;
            if(this.bearerFormat===undefined) this.bearerFormat = null;
            if(this.$ref===undefined) this.$ref = null;
            if(this.scheme===undefined) this.scheme = null;
            if(this.flows===undefined) this.flows = null;
            if(this.openIdConnectUrl===undefined) this.openIdConnectUrl = null;
            if(this.bearerFormat===undefined) this.bearerFormat = null;
            (() => {
                if(parent != null) {
                    this._parent = parent;
                    this._ownerDocument = parent.ownerDocument();
                }
            })();
        } else if(((typeof parent === 'string') || parent === null) && name === undefined) {
            let __args = arguments;
            let name : any = __args[0];
            super(name);
            if(this.$ref===undefined) this.$ref = null;
            if(this.scheme===undefined) this.scheme = null;
            if(this.flows===undefined) this.flows = null;
            if(this.openIdConnectUrl===undefined) this.openIdConnectUrl = null;
            if(this.bearerFormat===undefined) this.bearerFormat = null;
            if(this.$ref===undefined) this.$ref = null;
            if(this.scheme===undefined) this.scheme = null;
            if(this.flows===undefined) this.flows = null;
            if(this.openIdConnectUrl===undefined) this.openIdConnectUrl = null;
            if(this.bearerFormat===undefined) this.bearerFormat = null;
        } else if(((parent != null && parent instanceof <any>Node) || parent === null) && name === undefined) {
            let __args = arguments;
            {
                let __args = arguments;
                let name : any = null;
                super(name);
                if(this.$ref===undefined) this.$ref = null;
                if(this.scheme===undefined) this.scheme = null;
                if(this.flows===undefined) this.flows = null;
                if(this.openIdConnectUrl===undefined) this.openIdConnectUrl = null;
                if(this.bearerFormat===undefined) this.bearerFormat = null;
                if(this.$ref===undefined) this.$ref = null;
                if(this.scheme===undefined) this.scheme = null;
                if(this.flows===undefined) this.flows = null;
                if(this.openIdConnectUrl===undefined) this.openIdConnectUrl = null;
                if(this.bearerFormat===undefined) this.bearerFormat = null;
                (() => {
                    if(parent != null) {
                        this._parent = parent;
                        this._ownerDocument = parent.ownerDocument();
                    }
                })();
            }
        } else throw new Error('invalid overload');
    }

    /**
     * 
     * @return {string}
     */
    public getReference() : string {
        return this.$ref;
    }

    /**
     * 
     * @param {string} reference
     */
    public setReference(reference : string) {
        this.$ref = reference;
    }
}
AaiSecurityScheme["__class"] = "io.apicurio.datamodels.asyncapi.models.AaiSecurityScheme";
AaiSecurityScheme["__interfaces"] = ["io.apicurio.datamodels.core.models.common.IDefinition","io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IReferenceNode","io.apicurio.datamodels.core.models.common.INamed"];




